import { Citation, CitationDescription, CitationGrid, CitationIcons, CitationIndex, CitationTitle, } from "../components/Citation";
import { Pagination } from "../components/Pagination";
import { cn } from "../lib/utils";
import React, { useState } from "react";
/**
 * A paginated grid of link citations for when an agent answer references many
 * sources, automatically paging through large sets while staying compact for
 * a handful of items. Use it for sizeable, homogeneous link lists; for a few
 * rich, individually composed references use Citation with CitationGrid.
 * @summary Paginated grid of source citations.
 */
export function PaginatedCitationsGrid({ items, maxItemsPerPage = 12, }) {
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: maxItemsPerPage,
    });
    if (items.length === 0) {
        return null;
    }
    const { pageIndex, pageSize } = pagination;
    const startIndex = pageIndex * pageSize;
    const paginatedItems = items.slice(startIndex, startIndex + pageSize);
    return (React.createElement("div", { className: "flex w-full flex-col" },
        React.createElement(CitationGrid, null, paginatedItems.map((d, idx) => {
            return (React.createElement(Citation, { href: d.href, variant: "primary", key: idx },
                React.createElement(CitationIcons, null,
                    React.createElement(CitationIndex, null, startIndex + idx + 1),
                    d.icon),
                React.createElement(CitationTitle, null, d.title),
                React.createElement(CitationDescription, null, d.description)));
        })),
        React.createElement("div", { className: cn("pt-3", items.length > maxItemsPerPage ? "visible" : "collapse") },
            React.createElement(Pagination, { rowCount: items.length, pagination: pagination, setPagination: setPagination, size: "xs", showDetails: false, showPageButtons: false }))));
}
//# sourceMappingURL=PaginatedCitationsGrid.js.map